/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedConnectRouteImport } from './routes/_authed/connect'
import { Route as AuthedDeletedRouteImport } from './routes/_authed/deleted'
import { Route as AuthedNeedAccessRouteImport } from './routes/_authed/need-access'
import { Route as AuthedAccountAiRouteImport } from './routes/_authed/account/ai'
import { Route as AuthedAccountBillingRouteImport } from './routes/_authed/account/billing'
import { Route as AuthedAccountDeleteRouteImport } from './routes/_authed/account/delete'
import { Route as AuthedOauthConsentRouteImport } from './routes/_authed/oauth/consent'
import { Route as AuthedASlugIndexRouteImport } from './routes/_authed/a/$slug/index'
import { Route as AuthedASlugDataRouteImport } from './routes/_authed/a/$slug/data'
import { Route as AuthedASlugKeysRouteImport } from './routes/_authed/a/$slug/keys'
import { Route as AuthedASlugPreviewDraftIdRouteImport } from './routes/_authed/a/$slug/preview/$draftId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConnectRoute = AuthedConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDeletedRoute = AuthedDeletedRouteImport.update({
  id: '/deleted',
  path: '/deleted',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNeedAccessRoute = AuthedNeedAccessRouteImport.update({
  id: '/need-access',
  path: '/need-access',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountAiRoute = AuthedAccountAiRouteImport.update({
  id: '/account/ai',
  path: '/account/ai',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountBillingRoute = AuthedAccountBillingRouteImport.update({
  id: '/account/billing',
  path: '/account/billing',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountDeleteRoute = AuthedAccountDeleteRouteImport.update({
  id: '/account/delete',
  path: '/account/delete',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOauthConsentRoute = AuthedOauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedASlugIndexRoute = AuthedASlugIndexRouteImport.update({
  id: '/a/$slug/',
  path: '/a/$slug/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedASlugDataRoute = AuthedASlugDataRouteImport.update({
  id: '/a/$slug/data',
  path: '/a/$slug/data',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedASlugKeysRoute = AuthedASlugKeysRouteImport.update({
  id: '/a/$slug/keys',
  path: '/a/$slug/keys',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedASlugPreviewDraftIdRoute =
  AuthedASlugPreviewDraftIdRouteImport.update({
    id: '/a/$slug/preview/$draftId',
    path: '/a/$slug/preview/$draftId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/signin': typeof SigninRoute
  '/admin': typeof AuthedAdminRoute
  '/connect': typeof AuthedConnectRoute
  '/deleted': typeof AuthedDeletedRoute
  '/need-access': typeof AuthedNeedAccessRoute
  '/account/ai': typeof AuthedAccountAiRoute
  '/account/billing': typeof AuthedAccountBillingRoute
  '/account/delete': typeof AuthedAccountDeleteRoute
  '/oauth/consent': typeof AuthedOauthConsentRoute
  '/a/$slug/data': typeof AuthedASlugDataRoute
  '/a/$slug/keys': typeof AuthedASlugKeysRoute
  '/a/$slug/': typeof AuthedASlugIndexRoute
  '/a/$slug/preview/$draftId': typeof AuthedASlugPreviewDraftIdRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninRoute
  '/admin': typeof AuthedAdminRoute
  '/connect': typeof AuthedConnectRoute
  '/deleted': typeof AuthedDeletedRoute
  '/need-access': typeof AuthedNeedAccessRoute
  '/': typeof AuthedIndexRoute
  '/account/ai': typeof AuthedAccountAiRoute
  '/account/billing': typeof AuthedAccountBillingRoute
  '/account/delete': typeof AuthedAccountDeleteRoute
  '/oauth/consent': typeof AuthedOauthConsentRoute
  '/a/$slug/data': typeof AuthedASlugDataRoute
  '/a/$slug/keys': typeof AuthedASlugKeysRoute
  '/a/$slug': typeof AuthedASlugIndexRoute
  '/a/$slug/preview/$draftId': typeof AuthedASlugPreviewDraftIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/signin': typeof SigninRoute
  '/_authed/admin': typeof AuthedAdminRoute
  '/_authed/connect': typeof AuthedConnectRoute
  '/_authed/deleted': typeof AuthedDeletedRoute
  '/_authed/need-access': typeof AuthedNeedAccessRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/account/ai': typeof AuthedAccountAiRoute
  '/_authed/account/billing': typeof AuthedAccountBillingRoute
  '/_authed/account/delete': typeof AuthedAccountDeleteRoute
  '/_authed/oauth/consent': typeof AuthedOauthConsentRoute
  '/_authed/a/$slug/data': typeof AuthedASlugDataRoute
  '/_authed/a/$slug/keys': typeof AuthedASlugKeysRoute
  '/_authed/a/$slug/': typeof AuthedASlugIndexRoute
  '/_authed/a/$slug/preview/$draftId': typeof AuthedASlugPreviewDraftIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/admin'
    | '/connect'
    | '/deleted'
    | '/need-access'
    | '/account/ai'
    | '/account/billing'
    | '/account/delete'
    | '/oauth/consent'
    | '/a/$slug/data'
    | '/a/$slug/keys'
    | '/a/$slug/'
    | '/a/$slug/preview/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/admin'
    | '/connect'
    | '/deleted'
    | '/need-access'
    | '/'
    | '/account/ai'
    | '/account/billing'
    | '/account/delete'
    | '/oauth/consent'
    | '/a/$slug/data'
    | '/a/$slug/keys'
    | '/a/$slug'
    | '/a/$slug/preview/$draftId'
  id:
    | '__root__'
    | '/_authed'
    | '/signin'
    | '/_authed/admin'
    | '/_authed/connect'
    | '/_authed/deleted'
    | '/_authed/need-access'
    | '/_authed/'
    | '/_authed/account/ai'
    | '/_authed/account/billing'
    | '/_authed/account/delete'
    | '/_authed/oauth/consent'
    | '/_authed/a/$slug/data'
    | '/_authed/a/$slug/keys'
    | '/_authed/a/$slug/'
    | '/_authed/a/$slug/preview/$draftId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  SigninRoute: typeof SigninRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/connect': {
      id: '/_authed/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof AuthedConnectRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/deleted': {
      id: '/_authed/deleted'
      path: '/deleted'
      fullPath: '/deleted'
      preLoaderRoute: typeof AuthedDeletedRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/need-access': {
      id: '/_authed/need-access'
      path: '/need-access'
      fullPath: '/need-access'
      preLoaderRoute: typeof AuthedNeedAccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/ai': {
      id: '/_authed/account/ai'
      path: '/account/ai'
      fullPath: '/account/ai'
      preLoaderRoute: typeof AuthedAccountAiRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/billing': {
      id: '/_authed/account/billing'
      path: '/account/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AuthedAccountBillingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/account/delete': {
      id: '/_authed/account/delete'
      path: '/account/delete'
      fullPath: '/account/delete'
      preLoaderRoute: typeof AuthedAccountDeleteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/oauth/consent': {
      id: '/_authed/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof AuthedOauthConsentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/a/$slug/': {
      id: '/_authed/a/$slug/'
      path: '/a/$slug'
      fullPath: '/a/$slug/'
      preLoaderRoute: typeof AuthedASlugIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/a/$slug/data': {
      id: '/_authed/a/$slug/data'
      path: '/a/$slug/data'
      fullPath: '/a/$slug/data'
      preLoaderRoute: typeof AuthedASlugDataRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/a/$slug/keys': {
      id: '/_authed/a/$slug/keys'
      path: '/a/$slug/keys'
      fullPath: '/a/$slug/keys'
      preLoaderRoute: typeof AuthedASlugKeysRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/a/$slug/preview/$draftId': {
      id: '/_authed/a/$slug/preview/$draftId'
      path: '/a/$slug/preview/$draftId'
      fullPath: '/a/$slug/preview/$draftId'
      preLoaderRoute: typeof AuthedASlugPreviewDraftIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRoute
  AuthedConnectRoute: typeof AuthedConnectRoute
  AuthedDeletedRoute: typeof AuthedDeletedRoute
  AuthedNeedAccessRoute: typeof AuthedNeedAccessRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAccountAiRoute: typeof AuthedAccountAiRoute
  AuthedAccountBillingRoute: typeof AuthedAccountBillingRoute
  AuthedAccountDeleteRoute: typeof AuthedAccountDeleteRoute
  AuthedOauthConsentRoute: typeof AuthedOauthConsentRoute
  AuthedASlugDataRoute: typeof AuthedASlugDataRoute
  AuthedASlugKeysRoute: typeof AuthedASlugKeysRoute
  AuthedASlugIndexRoute: typeof AuthedASlugIndexRoute
  AuthedASlugPreviewDraftIdRoute: typeof AuthedASlugPreviewDraftIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRoute,
  AuthedConnectRoute: AuthedConnectRoute,
  AuthedDeletedRoute: AuthedDeletedRoute,
  AuthedNeedAccessRoute: AuthedNeedAccessRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAccountAiRoute: AuthedAccountAiRoute,
  AuthedAccountBillingRoute: AuthedAccountBillingRoute,
  AuthedAccountDeleteRoute: AuthedAccountDeleteRoute,
  AuthedOauthConsentRoute: AuthedOauthConsentRoute,
  AuthedASlugDataRoute: AuthedASlugDataRoute,
  AuthedASlugKeysRoute: AuthedASlugKeysRoute,
  AuthedASlugIndexRoute: AuthedASlugIndexRoute,
  AuthedASlugPreviewDraftIdRoute: AuthedASlugPreviewDraftIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  SigninRoute: SigninRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
